import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'RiskAssessmentResult',
    column_type: 'id',
  },
  created_at: {
    model_name: 'RiskAssessmentResult',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'RiskAssessmentResult',
    column_type: 'datetime',
  },
  account: {
    model_name: 'RiskAssessmentResult',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'account',
      model_name: 'Account',
      foreign_key: 'account_id',
    },
  },
  account_id: {
    model_name: 'RiskAssessmentResult',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'account',
      model_name: 'Account',
      foreign_key: 'account_id',
    },
  },
  risk_assessment: {
    model_name: 'RiskAssessmentResult',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'risk_assessment',
      model_name: 'RiskAssessment',
      foreign_key: 'risk_assessment_id',
    },
  },
  risk_assessment_id: {
    model_name: 'RiskAssessmentResult',
    column_type: 'belongs_to',
    extra: {
      polymorphic: '',
      association_name: 'risk_assessment',
      model_name: 'RiskAssessment',
      foreign_key: 'risk_assessment_id',
    },
  },
  score: {
    model_name: 'RiskAssessmentResult',
    column_type: 'integer',
  },
  risk_assessment_level: {
    model_name: 'RiskAssessmentResult',
    column_type: 'enum',
  },
  file: {
    model_name: 'RiskAssessmentResult',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  risk_assessment_answers: {
    model_name: 'RiskAssessmentResult',
    column_type: 'has_many',
    extra: {
      association_name: 'risk_assessment_answers',
      model_name: 'RiskAssessmentAnswer',
      foreign_key: 'risk_assessment_result_id',
    },
  },
  risk_assessment_answer_ids: {
    model_name: 'RiskAssessmentResult',
    column_type: 'has_many',
    extra: {
      association_name: 'risk_assessment_answers',
      model_name: 'RiskAssessmentAnswer',
      foreign_key: 'risk_assessment_result_id',
    },
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
